import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const WhistleblowingPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  whistleblowingOfficerContact,
  hrContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Whistleblowing_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Whistleblowing Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        To provide a clear and confidential process for employees and other stakeholders to report concerns about wrongdoing, malpractice, or unethical behaviour within {clientName || "the Company"} without fear of retaliation.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all employees, contractors, agency workers, and third parties associated with the company.
      </p>

      <h4 className="section-title">3. What to Report</h4>
      <ul>
        <li>Criminal offences or suspected criminal activity.</li>
        <li>Health and safety risks or breaches.</li>
        <li>Financial malpractice, fraud, or corruption.</li>
        <li>Breaches of company policies, ethics, or regulatory requirements.</li>
        <li>Any conduct that could cause harm to individuals or the company’s reputation.</li>
      </ul>

      <h4 className="section-title">4. Protection for Whistleblowers</h4>
      <p className="section-content">
        The company is committed to protecting whistleblowers from any form of retaliation, victimisation, or unfair treatment. Confidentiality will be maintained throughout investigations, subject to legal requirements.
      </p>

      <h4 className="section-title">5. Reporting Procedure</h4>
      <p className="section-content">
        Employees should report concerns promptly to their line manager, HR, or the designated Whistleblowing Officer. If inappropriate, concerns may be raised with external regulatory bodies.
      </p>

      <h4 className="section-title">6. Investigation and Response</h4>
      <p className="section-content">
        All reports will be taken seriously, investigated thoroughly and fairly, and appropriate action will be taken. Feedback will be provided to the whistleblower where possible.
      </p>

      <h4 className="section-title">7. Roles and Responsibilities</h4>
      <p><strong>Whistleblowing Officer:</strong> {whistleblowingOfficerContact || "[Insert Contact]"}</p>
      <p><strong>Human Resources:</strong> {hrContact || "[Insert Contact]"}</p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and agree to comply with the Whistleblowing Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default WhistleblowingPolicy;
